<table class="dynamic-table" [class.auto-table-layout]="useAutoTableLayout" role="table">
  <thead>
    <tr>
      <th class="blank-column"></th>
      @if (hasCheckboxColumn) {
        <th class="checkbox-column"><input type="checkbox" id="selectAllCheckbox" (change)="toggleAllCheckboxes($event)"></th>
      }
      @for (column of columns; track column) {
        <th class="sort-header xx-small-bold-text" (click)="sort(column)">{{ formatHeaderText(column.header) }}@if (hasSort(column)) {
          <app-icon icon="{{getSortIcon(column)}}" class="sort-icon"></app-icon>
        }</th>
      }
      @if (canExportData) {
        <th class="export-data-btn"><div class="button-wrapper">
          <button class="export custom-button-small-secondary xx-small-bold-text d-flex flex-column align-items-center" (click)="emitExportDataEvent()">Export Data</button>
        </div></th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of paginatedData; track row; let i = $index) {
      <tr class="align-top">
        <td class="blank-column-cell"></td>
        @if (hasCheckboxColumn) {
          <td class="checkbox-cell"><input type="checkbox" [ngModel]="row.isSelected" (change)="toggleCheckbox(i)"></td>
        }
        @for (column of columns; track column; let first = $first) {
          <td [ngClass]="{'not-first': !first, '': first}"  class="normal-td small-reg-text" [attr.data-cell]="column.header || null">
            @if (isStatus(row[column.field], column.field) !== 'false') {
              <div class="d-flex align-items-center gap-2">
                <div [ngClass]="isStatus(row[column.field], column.field) " class="status">{{ String(row[column.field]) | enumConstant }}</div>
                <span class="x-small-italic">
                  {{row.supervisorJoinDate ? 'Joined '+ (row.supervisorJoinDate | date: 'MM/dd/yyyy' ) : ''}}
                </span>
              </div>
            }
            @if (isStatus(row[column.field], column.field) === 'false' && isOrgName(column.field)) {
              <span class="underline" (click)="navigateToRecord(row)">
                {{ row[column.field] }}
              </span>
            }
            @if (isTimeLogged(column.field)) {
              <span> {{ (Number(row[column.field]) | decimalToInteger) }} </span>
            }
            @if (isTerm(column.field)) {
              <span> {{ (String(row[column.field]) | term) }} </span>
            }
            @if (isOrgType(column.field)) {
              <span> {{ (String(row[column.field]) | enumConstant) }} </span>
            }
            @if (isAction(column.field)) {
              <span>
                <app-icon icon="{{getEventActionIcon(row[column.field])}}" class="action-icon" [matTooltip]="getEventChanges(row)"></app-icon>
                {{ (String(row[column.field]) | enumConstant) }}
              </span>
            }
            @if (isRating(column.field)) {
              <span>
                <app-rating-widget [name]="'supervisor'" [initialRating]=ratingAsString(row[column.field]) [readOnly]="true" ></app-rating-widget>
              </span>
            }
            @if (isSupervisorLabel(column.field)) {
              <span>
                <div [ngClass]="supervisorLabel(row[column.field])" >{{ String(row[column.field]) }}</div>
              </span>
            }
            @if (hasNoSpecialFormatting(row[column.field], column.field, column.dataType)) {
              <span> {{ row[column.field] }} </span>
            }
            @if (isDate(column.field)) {
              <div>
                <span>{{ (String(row[column.field]) | actionDate) }}</span>
                <br>
                <span>{{ (String(row[column.field])  | date:'shortTime') }}</span>
              </div>
            }
            @if (isDateTime(column.dataType)) {
              <div>
                <span>{{ (String(row[column.field])  | actionDate) }}</span>
                <br>
                <span>{{ (String(row[column.field])  | date:'shortTime') }}</span>
              </div>
            }
            @if (isEmail(column.field)) {
              <span>
                <a href="mailto:{{ row[column.field] }}" title="{{row[column.field]}}" class="small-email-text ellipsis-text">{{ row[column.field] }}</a>
              </span>
            }
            @if (hasStackableContactData(column.dataType)) {
              <div>
                <a href="mailto:{{ getContactInfo(row[column.field]).email }}" title="{{ getContactInfo(row[column.field]).email }}" class="small-email-text ellipsis-text">{{ getContactInfo(row[column.field]).email }}</a>
                @if(!!getContactInfo(row[column.field]).contactEmail) {
                  <div class="d-flex flex-row align-baseline">
                    <app-icon icon="star" class="small-star"></app-icon>
                    <a href="mailto:{{ getContactInfo(row[column.field]).contactEmail }}" title="{{ getContactInfo(row[column.field]).contactEmail }}" class="small-email-text ellipsis-text">
                      {{ getContactInfo(row[column.field]).contactEmail }}
                    </a>
                  </div>
                }
                <br>
                  {{ getContactInfo(row[column.field]).phone | phoneNumber }}
                </div>
              }
              @if (hasSupervisorData(column.dataType)) {
                <div>
                  {{getSupervisorData(row[column.field]).firstName}} {{getSupervisorData(row[column.field]).lastName}}
                  <br>
                    <a href="mailto:{{getSupervisorData(row[column.field]).email | emailCleanup}}" title="{{getSupervisorData(row[column.field]).email}}" class="small-email-text ellipsis-text">{{getSupervisorData(row[column.field]).email}}</a>
                    @if(getSupervisorData(row[column.field]).contactEmail !== getSupervisorData(row[column.field]).email) {
                      <div class="d-flex flex-row">
                        <app-icon icon="star" class="small-star" [matTooltip]="'This is the user\'s preferred contact email'"></app-icon>
                        <a href="mailto:{{getSupervisorData(row[column.field]).contactEmail | emailCleanup}}" title="{{getSupervisorData(row[column.field]).contactEmail}}" class="small-email-text ellipsis-text">
                        {{getSupervisorData(row[column.field]).contactEmail}}</a>
                      </div>
                    }
                  </div>
                }
                @if (hasStudentDisplayData(column.dataType)) {
                  <div>
                    {{getStudentDisplayData(row[column.field]).name}}
                    <br>
                      <a href="mailto:{{getStudentDisplayData(row[column.field]).email | emailCleanup}}" title="{{getStudentDisplayData(row[column.field]).email}}" class="small-email-text ellipsis-text">{{getStudentDisplayData(row[column.field]).email}}</a>
                    </div>
                  }
                  @if (hasStringArray(column.dataType)) {
                    <div>
                      @for (changeType of getStringArrayData(row[column.field]); track changeType) {
                        <div>
                          {{changeType}}
                          <br>
                          </div>
                        }
                      </div>
                    }
                    @if (hasStackableOppData(column.dataType) && getStackableDataCount(row[column.field]) === 1) {
                      <span>
                        {{getOpportunityData(row[column.field])[0].name}} ({{getOpportunityData(row[column.field])[0].term | term}})
                      </span>
                    }
                    @if (hasStackableOppData(column.dataType) && getStackableDataCount(row[column.field]) > 1) {
                      <button class="custom-button-small-secondary d-flex flex-column align-items-center"
                        (click)="emitViewOpportunitiesEvent(getOpportunityData(row[column.field]), row['name'])">
                        {{getStackableDataCount(row[column.field])}} {{column.header}}
                      </button>
                    }
                    @if (hasStackableOrgData(column.dataType) && getStackableDataCount(row[column.field]) === 1) {
                      <span class="underline" (click)="navigateToRecord(row)">
                        {{getOrganizationData(row[column.field])[0].name}}
                      </span>
                    }
                    @if (hasStackableOrgData(column.dataType) && getStackableDataCount(row[column.field]) > 1) {
                      <button class="custom-button-small-secondary d-flex flex-column align-items-center"
                        (click)="emitViewOrganizationsEvent(getOrganizationData(row[column.field]), row['name'])">
                        {{getStackableDataCount(row[column.field])}} {{column.header}}
                      </button>
                    }
                    @if (hasStackableSupData(column.dataType) && getStackableDataCount(row[column.field]) < 1) {
                      <span>
                        no other supervisors
                      </span>
                    }
                    @if (hasStackableSupData(column.dataType) && getStackableDataCount(row[column.field]) === 1) {
                      <span>
                        {{getSupervisorListData(row[column.field])[0].firstName}}  {{getSupervisorListData(row[column.field])[0].lastName}}
                        <br>
                          <a href="mailto:{{getSupervisorListData(row[column.field])[0].email | emailCleanup}}" title="{{getSupervisorListData(row[column.field])[0].email}}"
                          class="small-email-text ellipsis-text">{{getSupervisorListData(row[column.field])[0].email}}</a>
                          @if(getSupervisorListData(row[column.field])[0].contactEmail !== null && getSupervisorListData(row[column.field])[0].contactEmail !== getSupervisorListData(row[column.field])[0].email) {
                            <div class="d-flex flex-row align-baseline">
                              <app-icon icon="star" class="small-star"></app-icon>
                              <a href="mailto:{{getSupervisorListData(row[column.field])[0].contactEmail | emailCleanup}}" title="{{getSupervisorListData(row[column.field])[0].contactEmail}}" class="small-email-text ellipsis-text">
                              {{getSupervisorListData(row[column.field])[0].contactEmail}}</a>
                            </div>
                          }
                        </span>
                      }
                      @if (hasStackableSupData(column.dataType) && getStackableDataCount(row[column.field]) > 1) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center"
                          (click)="emitViewSupervisorsEvent(getSupervisorListData(row[column.field]), row['orgName'])" >
                          {{getStackableDataCount(row[column.field])}} {{column.header}}
                        </button>
                      }
                      @if (isStudentId(column.field)) {
                        <span [matTooltip]="String(row[column.field])">
                          {{ row[column.field] }}
                        </span>
                      }
                    </td>
                  }
                  @if (hasActionColumn) {
                    <td class="action-cell">
                      <div class="dropdown-wrapper">
                        <select #actionSelect class="custom-dropdown"
                          aria-labelledby="actionLabel" (change)="getActionSelected(row, $event, actionSelect)">
                          <option disabled selected value="Actions">Actions</option>
                          @for (action of actionTypes; track action) {
                            @if (shouldNotShowActionInDropdown(action, row)) {}
                              @else {
                              <option class="x-small-medium-text" [ngValue]="action" >{{action}}</option>
                            }
                          }
                        </select>
                        <app-icon icon="chevron-down" class="dropdown-chevron" [ngClass]=" row.isExpanded ? 'flipped' : ''"></app-icon>
                      </div>
                    </td>
                  }
                  @if (showRequestCell() && isActiveVolunteers ) {
                    <td class="request-cell ">
                      @if (isActiveVolunteers && row.supervisorEvalAvailable && !row.supervisorEvalRejected) {
                        <button class="custom-button-small-primary-dark-blue d-flex flex-column align-items-center" (click)="emitSubmitEvalEvent(row.id)">Submit Evaluation</button>
                      }
                      @if (isActiveVolunteers && row.supervisorEvalAvailable && row.supervisorEvalRejected) {
                        <button class="custom-button-small-primary-dark-blue d-flex flex-column align-items-center" (click)="emitSubmitEvalEvent(row.id)">Resubmit Evaluation</button>
                      }
                      @if (isActiveVolunteers && !row.supervisorEvalAvailable && row.supervisorEvalRejected) {
                        <div class="x-small-medium-text status-yellow" >Pending Resubmission</div>
                      }
                      @if (row.supervisorEvalComplete) {
                        <div class="x-small-medium-text status-green" >Completed</div>
                      }
                    </td>
                  }
                  @if (showRequestCell()) {
                    <td class="request-cell f-row">
                      @if ((isAnnouncement && row['status'] === 'Inactive')) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitChangeAnnouncementStatusEvent(row.id, true)">Start</button>
                      }
                      @if ((isAnnouncement && row['status'] === 'Active')) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitChangeAnnouncementStatusEvent(row.id, false)">Stop</button>
                      }
                      @if (isSubmittedEvaluations && canViewEvals) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitViewEvalsEvent(row.id)">View Evals</button>
                      }
                      @if ((row['status'] === 'NEW' || isAnnouncement) && !hasEditSupervisorColumn) {
                        <div class="vertical-bar"></div>
                      }
                      @if (hasViewRequestColumn) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center"
                                (click)="emitViewRequestEvent(row.id)"
                                [disabled]="oppRequestHasPendingOrg(row)"
                                [matTooltip]="oppRequestHasPendingOrg(row) ? disabledOppRequestTooltip : ''"
                                [attr.aria-label]="getViewRequestAriaLabel(row['name'])">
                          View Request
                        </button>
                      }
                      @if (hasReviewRequestColumn) {
                        <button class="custom-button-small-primary-dark-blue d-flex flex-column align-items-center" (click)="emitReviewRequestEvent(row.id)">Review Request</button>
                      }
                      @if (hasViewDetailsColumn) {
                        <button class="custom-button-small-primary-dark-blue d-flex flex-column align-items-center" (click)="emitReviewRequestEvent(row.id)">View Details</button>
                      }
                      @if (hasSwapSupervisorButton) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitSwapSupervisorEvent(row.id)">Swap Supervisor</button>
                      }
                      @if (isAnnouncement) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitViewAnnouncementEvent(row.id)">View/Edit</button>
                      }
                      @if (isAnnouncement) {
                        <button class="custom-button-small-primary-red d-flex flex-column align-content-center" (click)="emitDeleteAnnouncementEvent(row.id)">Delete</button>
                      }
                      @if (hasViewColumn) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitViewOpportunityEvent(row.id)">View</button>
                      }
                      @if (hasEditColumn) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitViewEditTermEvent(row.id)">Edit</button>
                      }
                      @if (hasEditSupervisorColumn && row['status'] === ContractStatus.NEW) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitEditSupervisorEvent(row.id)">Edit Supervisor</button>
                      }
                      @if (hasReplaceLeadSupervisorColumn) {
                        <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="emitSelectLeadSupervisorEvent(row)">Select Replacement</button>
                      }
                      @if (hasManualResolution) {
                        <button class="custom-button-small-secondary d-flex flex-column" (click)="emitManualResolutionEvent(row.id)">Resolved Manually</button>
                      }
                      @if (isFailedSubmission) {
                        <button class="custom-button-small-primary-dark-blue d-flex flex-column resubmit-btn" (click)="emitRetrySubmissionEvent(row.id)">Resubmit</button>
                      }
                    </td>
                  }
                  <td class="blank-column-cell align-middle">
                    @if (getActionItemsForPastOpportunity(row.id) | async; as actionItemCount) {
                      @if (actionItemCount > 0) {
                        <span class="badge rounded-circle text-white notification-badge">{{ actionItemCount }}</span>
                      }
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (isPaginated) {
            <div class="pagination-controls f-row">
              <div class="page-indicator x-small-medium-text f-row">
                Show
                <div class="dropdown-wrapper-small">
                  <select class="custom-dropdown-small x-small-medium-text" [(ngModel)]="pageSize" (change)="changePageSize()">
                    @for (option of pageSizeOptions; track option) {
                      <option [ngValue]="option">{{option}}</option>
                    }
                  </select>
                  <app-icon icon="chevron-down" class="dropdown-chevron-small"></app-icon>
                </div>
                at a time
              </div>
              <div class="pagination f-row">
                <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="goToPreviousPage()" [disabled]="currentPage === 1">
                  <app-icon icon="arrow-left" class="large-icon"></app-icon>
                </button>
                <div class="page-selector f-row">
                  Page
                  @if (totalPages > 1) {
                    <div class="dropdown-wrapper-small">
                      <select class="custom-dropdown-small x-small-medium-text" [(ngModel)]="currentPage" (ngModelChange)="goToPage($event)" >
                        @for (page of pageNumbers; track page) {
                          <option [ngValue]="page">{{page}}</option>
                        }
                      </select>
                      <app-icon icon="chevron-down" class="dropdown-chevron-small"></app-icon>
                    </div>
                  }
                  @if (totalPages === 1) {
                    <span>1</span>
                  }
                  of {{ totalPages }}
                </div>
                <button class="custom-button-small-secondary d-flex flex-column align-items-center" (click)="goToNextPage()" [disabled]="currentPage === totalPages">
                  <app-icon icon="arrow-right" class="large-icon"></app-icon>
                </button>
              </div>
            </div>
          }

          @if (isBlacklistModalOpen) {
            <app-blacklist-modal [typeName]="blacklistType" [isLeadSupervisor]="isLead" (blacklistReasonEvent)="confirmBlacklist($event)" (closeModal)="closeModals()"></app-blacklist-modal>
          }
